import { ChildPositionData } from "entities/project-children/lib/getChildMoveData"

import { ProjectItemType, ProjectParentTypename } from "./Project"

export const CREATE_PROJECT = "CREATE_PROJECT" as const
export const UPDATE_PROJECT = "UPDATE_PROJECT" as const
export const DUPLICATE_PROJECT = "DUPLICATE_PROJECT" as const
export const DELETE_PROJECT = "DELETE_PROJECT" as const
export const CHANGE_PROJECT_OWNER = "CHANGE_PROJECT_OWNER" as const
export const IMPORT_XLSX_PROJECT = "IMPORT_XLSX_PROJECT" as const

export const CREATE_PRODUCT_POSITION = "CREATE_PRODUCT_POSITION" as const
export const BATCH_CREATE_PRODUCT_POSITION =
  "BATCH_CREATE_PRODUCT_POSITION" as const
export const UPDATE_PRODUCT_POSITION = "UPDATE_PRODUCT_POSITION" as const
export const DELETE_PRODUCT_POSITION = "DELETE_PRODUCT_POSITION" as const
export const UPDATE_PRODUCT_POSITION_POSITION =
  "UPDATE_PRODUCT_POSITION_POSITION" as const

export const CREATE_SPECIAL_PRICE_GROUP = "CREATE_SPECIAL_PRICE_GROUP" as const
export const DELETE_SPECIAL_PRICE_GROUP = "DELETE_SPECIAL_PRICE_GROUP" as const
export const DELETE_PROJECT_CHILDREN = "DELETE_PROJECT_CHILDREN" as const

export const CREATE_FAVORITE = "CREATE_FAVORITE" as const
export const BATCH_CREATE_FAVORITE = "BATCH_CREATE_FAVORITE" as const

export const CREATE_ROOM = "CREATE_ROOM" as const
export const DUPLICATE_ROOM = "DUPLICATE_ROOM" as const
export const UPDATE_ROOM = "UPDATE_ROOM" as const
export const DELETE_ROOM = "DELETE_ROOM" as const

export const CREATE_FLOOR = "CREATE_FLOOR" as const
export const DUPLICATE_FLOOR = "DUPLICATE_FLOOR" as const
export const UPDATE_FLOOR = "UPDATE_FLOOR" as const
export const DELETE_FLOOR = "DELETE_FLOOR" as const

export const CREATE_PROJECT_CHILD = "CREATE_PROJECT_CHILD" as const

export interface ProjectsAPIRequestContext {
  projectID: string
  itemID: string
  itemType: ProjectItemType
}

export interface ProjectsAPIPositionUpdateRequestContext
  extends ProjectsAPIRequestContext,
    ChildPositionData {}

export interface ProjectsAPIDeleteRequestContext
  extends ProjectsAPIRequestContext {
  parentID: string
  parentType: ProjectParentTypename
}

export type ProjectsAPIMutationType =
  | typeof CREATE_PROJECT
  | typeof UPDATE_PROJECT
  | typeof DUPLICATE_PROJECT
  | typeof DELETE_PROJECT
  | typeof IMPORT_XLSX_PROJECT
  | typeof CREATE_PRODUCT_POSITION
  | typeof BATCH_CREATE_PRODUCT_POSITION
  | typeof UPDATE_PRODUCT_POSITION
  | typeof UPDATE_PRODUCT_POSITION_POSITION
  | typeof DELETE_PRODUCT_POSITION
  | typeof CREATE_SPECIAL_PRICE_GROUP
  | typeof DELETE_SPECIAL_PRICE_GROUP
  | typeof DELETE_PROJECT_CHILDREN
  | typeof CREATE_ROOM
  | typeof UPDATE_ROOM
  | typeof DELETE_ROOM
  | typeof CREATE_FAVORITE
  | typeof BATCH_CREATE_FAVORITE
  | typeof DUPLICATE_ROOM
  | typeof CHANGE_PROJECT_OWNER
  | typeof CREATE_FLOOR
  | typeof UPDATE_FLOOR
  | typeof DELETE_FLOOR
  | typeof DUPLICATE_FLOOR

export const projectMutations = [
  CREATE_PROJECT,
  UPDATE_PROJECT,
  DUPLICATE_PROJECT,
  DELETE_PROJECT,
  CHANGE_PROJECT_OWNER,
  IMPORT_XLSX_PROJECT
]

export const productPositionMutations = [
  CREATE_PRODUCT_POSITION,
  BATCH_CREATE_PRODUCT_POSITION,
  UPDATE_PRODUCT_POSITION,
  UPDATE_PRODUCT_POSITION_POSITION,
  DELETE_PRODUCT_POSITION,
  CREATE_FAVORITE,
  BATCH_CREATE_FAVORITE
]

export const roomMutations = [
  CREATE_ROOM,
  DUPLICATE_ROOM,
  UPDATE_ROOM,
  DELETE_ROOM
]

export const floorMutations = [
  CREATE_FLOOR,
  DUPLICATE_FLOOR,
  UPDATE_FLOOR,
  DELETE_FLOOR
]

export const specialPriceGroupMutations = [
  CREATE_SPECIAL_PRICE_GROUP,
  DELETE_SPECIAL_PRICE_GROUP
]

export const projectChildrenMutations = [DELETE_PROJECT_CHILDREN]

export const projectsAPIMutations: ProjectsAPIMutationType[] = [
  ...projectMutations,
  ...productPositionMutations,
  ...specialPriceGroupMutations,
  ...roomMutations,
  ...floorMutations,
  ...projectChildrenMutations
]
